import React from "react";
//import PropTypes from 'prop-types';

import { FormSection, FormFieldset } from "playground/cms/Form";
import Field from "containers/Field";
import { useActions, useFetch } from "state/hooks";
import { create, pathAppend, pathDetach } from "state/actions/data";
import Button from "components/Button";
import AggregateRoot from "containers/AggregateRoot";
import IconButton from "components/IconButton";
import Popover from "components/Popover";
import uuid from "uuid/v4";

function DefaultLayoutsField(props) {
    const { value, path, onChange } = props;
    const { onCreateEntity, onAttach, onDelete } = useActions({
        onCreateEntity: create,
        onAttach: pathAppend,
        onDelete: pathDetach,
    });
    const onCreate = () => {
        const newId = uuid();
        onCreateEntity("cms.layout-ref", { id: newId });
        onAttach(path, newId);
    };
    const val = value || [];
    return (
        <div className={"rows gap-sm"}>
            {val.map((id) => (
                <LayoutRef
                    key={id}
                    id={id}
                    onDelete={() => onDelete(path, id)}
                />
            ))}
            <div className={"cols cols-left"}>
                <Button color={"default"} onClick={onCreate}>
                    Dodaj
                </Button>
            </div>
        </div>
    );
}

function LayoutRef(props) {
    const { id, onDelete } = props;
    return (
        <AggregateRoot type={"cms.layout-ref"} id={id} disableSubmit={true}>
            <div className={"cols cols-middle gap-md"}>
                <Field
                    id={"entry_type"}
                    fieldType={"select"}
                    source={"schema:entries.types"}
                    label={"Typ wpisu"}
                />
                <Field
                    id={"layout"}
                    fieldType={"select"}
                    source={"api:cms.layouts"}
                    label={"Szablon"}
                />
                <div className={"cols cols-middle"}>
                    <Popover
                        trigger={({ onClick }) => (
                            <IconButton
                                icon={"mui-settings"}
                                onClick={onClick}
                            />
                        )}
                        content={({ onClose }) => (
                            <div className={"rows gap-sm pad-md"}>
                                <Field
                                    id={"tags"}
                                    fieldType={"select"}
                                    source={"api:cms.tags"}
                                    label={"Tagi"}
                                    multiple={true}
                                    variant={"inline"}
                                />
                                <Field
                                    id={"archived"}
                                    fieldType={"checkbox"}
                                    label={"Archiwalne"}
                                    variant={"inline"}
                                />
                            </div>
                        )}
                    />
                    <IconButton icon={"mui-close"} onClick={onDelete} />
                </div>
            </div>
        </AggregateRoot>
    );
}
export function PageLayoutSettings(props) {
    const { id } = props;
    useFetch({
        type: "cms.layouts",
        list: "api:cms.layouts",
    });
    return (
        <FormSection name={"Konfiguracja podstron i szablonów"}>
            <FormFieldset>
                <Field
                    id={"sitemap_entry_types"}
                    fieldType={"select"}
                    source={"schema:entries.types"}
                    label={"Typy podstron"}
                    multiple={true}
                />

                <Field
                    id={"default_layout"}
                    fieldType={"select"}
                    source={"api:cms.layouts"}
                    label={"Domyślny szablon dla podstron"}
                />
                <Field
                    id={"default_layout_offers"}
                    fieldType={"select"}
                    source={"api:cms.layouts"}
                    label={"Domyślny szablon dla pakietów"}
                />
                <Field
                    id={"default_layouts"}
                    path={["cms.settings", id, "default_layouts"]}
                    FieldComponent={DefaultLayoutsField}
                />
            </FormFieldset>
        </FormSection>
    );
}

PageLayoutSettings.propTypes = {};

PageLayoutSettings.defaultProps = {};

export default PageLayoutSettings;
